<template>
  <b-container fluid>
    <b-row>
      <b-modal
        id="modal-resume"
        centered
        title="You have an Unfinished Test"
        ok
        hide-footer
        hide-header
      >
        <p>
          You have an Unfinished Test which will resume in {{ countdown }}secs
        </p>
      </b-modal>
      <b-col>
        

        <div class="card p-3 m-lg-3 mb-2">
          <div class="mt-5">
            <b-alert
              dismissible
              :show="discountdetails.discount_season"
              variant="info"
            >
              <p class="discount-text">
                Discount alert! {{ discountdetails.discount_title }}!
              </p>
              <p class="discount-text">
                <strong class="discount-value"
                  >{{ discountdetails.discount_percentage }}%</strong
                >
                off on all upgrades
              </p>
              <b-button class=" p-lg-2" :to="{ name: 'upgrade' }" variant="info"
                >Upgrade NOW</b-button
              >
            </b-alert>
          </div>
        </div>

        <div class="card p-3 m-lg-3 mb-2">
          <div class="header-card">
            <p class="card-title">Testspace Details</p>
          </div>
          <div class="body-card">
            <div class="field-division">
              <span class="field-label">Test Title:</span>
              <h5 class="field-value">{{ usecurrenttestspace.test_title }}</h5>
            </div>

            <div class="field-division">
              <span class="field-label">Test Description:</span>
              <h5 class="field-value">
                {{ usecurrenttestspace.test_description }}
              </h5>
            </div>

            <div
              v-if="usecurrenttestspace.test_structure == 'Section'"
              class="field-division"
            >
              <span class="field-label">Test Level</span>
              <div class="field-value">
                <b-badge variant="info"
                  >{{ usecurrenttestspace.test_level }}
                </b-badge>
              </div>
            </div>

            <div
              v-if="usecurrenttestspace.test_structure == 'Section'"
              class="field-division"
            >
              <span class="field-label">Test Course</span>
              <div class="field-value">
                <b-badge variant="info"
                  >{{ usecurrenttestspace.test_course }}
                </b-badge>
              </div>
            </div>

            <div
              class="field-division"
              v-if="usecurrenttestspace.test_structure == 'Subject'"
            >
              <span class="field-label">Test Subjects</span>
              <div class="field-value">
                <b-badge
                  variant="info"
                  v-for="subject in usecurrenttestspace.test_subjects"
                  :key="subject"
                  class="p-2 m-2 subtext"
                  >{{ subject }}</b-badge
                >
              </div>
              <!-- <b-form-checkbox-group id="selectsubject" :disabled="true" :options="" name="subjectspo" stacked></b-form-checkbox-group> -->
            </div>
          </div>

          <!-- <div class="footer-edit text-right mt-3">
                        <b-button class="v-button p-lg-2" type="submit" variant="success">Update <b-icon-pencil-square></b-icon-pencil-square></b-button>
                    </div> -->
        </div>

        <div class="card p-3 m-lg-3 mb-2">
          <div class="header-card">
            <p class="card-title">Take Test Details</p>
          </div>
          <div class="body-card">
            <div class="field-division">
              <span class="field-label">Test Mode:</span>
              <h5 class="field-value">{{ usecurrenttestspace.test_mode }}</h5>
            </div>

            <div class="field-division">
              <span class="field-label">Test Status:</span>
              <h5 class="field-value">
                This test is currently
                <b-badge
                  class="p-2 m-2"
                  :variant="usecurrenttestspace.test_status == 'Closed'
                      ? 'danger'
                      : 'success'"
                  >{{ usecurrenttestspace.test_status }}</b-badge
                >
              </h5>
              <p class="field-value">{{ usecurrenttestspace.reason }}</p>
            </div>

            <div class="field-division">
              <span class="field-label">Test Frequency:</span><br />
              <span class="info-span"
                >*This is the number of times you can take this test</span
              ><br />
              <span class="info-span"
                >*A Test Frequency of zero(0) indicates you can take this Test
                for any number of times</span
              >
              <div class="field-value">
                This test can only be taken
                <b-badge size="lg" class="p-2 m-2"
                  >{{ usecurrenttestspace.test_frequency }} time{{
                    usecurrenttestspace.user_frequency > 1 ? "s" : ""
                  }}</b-badge
                >
              </div>
              <div class="field-value">
                This Test is Currently Unlocked<b-badge
                  class="p-2 m-2"
                  :variant="
                    usecurrenttestspace.take_lock == 'Locked'
                      ? 'danger'
                      : 'success'"
                  >{{ usecurrenttestspace.take_lock }}</b-badge
                >
                because {{ usecurrenttestspace.lock_reason }}
              </div>
              <!-- <p class="field-value"></p> -->
              <p class="field-value">
                You have taken this test
                <b-badge
                  class="p-2 m-2"
                  :variant="
                    usecurrenttestspace.user_frequency ==
                    usecurrenttestspace.test_frequency
                      ? 'danger'
                      : 'success'"
                  >{{ usecurrenttestspace.user_frequency }} time{{
                    usecurrenttestspace.user_frequency > 1 ? "s" : ""
                  }}</b-badge
                >
              </p>
            </div>
          </div>

          <div class="footer-edit text-right mt-3">
            <!-- <b-button class="" type="submit" variant="success">Take <b-icon-pencil-square></b-icon-pencil-square></b-button> -->
            <b-overlay
              :show="proceeding"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="w-100"
            >
              <b-button
                type="submit"
                :disabled="
                  usecurrenttestspace.take_lock == 'Locked' ||
                    usecurrenttestspace.test_status == 'Closed'
                "
                class="w-50 p-2 v-button p-lg-2"
                variant="success"
                @click="takeTest()"
              >
                Take Test Now
              </b-button>
            </b-overlay>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import store from "@/store";

export default {
  data() {
    return {
      usecurrentorg: [],
      testspacesarray: [],
      usecurrenttestspace: [],
      select: this.getselected(),
      countdown: 5,
      proceeding: false,
      loading: false
    };
  },

  created() {
    this.fetchTestspaces();
    let testspaceid = this.$route.params.trackid;

    // let currentorg = this.orgspacearray.filter(
    //   x => x.organization == organization
    // );
    // this.usecurrentorg = currentorg;
    this.testspacesarray = this.orgspacearray;
    let currenttestspace = this.testspacesarray.filter(
      x => x.trackid == testspaceid
    );
    this.usecurrenttestspace = currenttestspace[0];
    // console.log(currenttestspace)
  },

  // beforeRouteEnter(to, from, next) {
  //   store.dispatch("admin/fetchOrganizationplan");
  //   next();
  // },
  watch: {
    countdown(oldval, newval) {
      // console.log(oldval)
      // console.log(newval)
      if (oldval > newval) {
        this.reduceCountdown();
      }
    }
  },

  methods: {
    ...mapActions("admin", [
      "fetchOrganization",
      "fetchOrganizationplan",
      "updateOrganization",
      "fetchTestspaces"
    ]),
    ...mapActions("exam", ["setSelect"]),
    async fetchData() {
      this.loading = true;
      try {
        await this.fetchOrganizationplan();
        this.loading = false;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    getselected() {
      return {
        organization: "",
        category: null,
        institution: null,
        institution_id: null,
        level: null,
        course: null,
        scholarship: null,
        subjects: [],
        topics: [],
        reducer: 25,
        questionspertopic: 5,
        minutesperquestion: 1,
        mode: "Prototype",
        testspaceid: "",
        testsource: "thirdparty",
        candidate: this.$store.state.loginmaster.details
      };
    },
    takeTest() {
      this.proceeding = true;

      this.select.organization = this.usecurrenttestspace.organization;
      this.select.category = this.usecurrenttestspace.test_category;
      this.select.institution = this.usecurrenttestspace.test_institution;
      this.select.institution_id = this.usecurrenttestspace.test_institution_id;
      this.select.level = this.usecurrenttestspace.test_level;
      this.select.course = this.usecurrenttestspace.test_course;
      this.select.subjects = this.usecurrenttestspace.test_subjects;
      this.select.mode = this.usecurrenttestspace.test_mode;
      this.select.testspaceid = this.usecurrenttestspace.trackid;
      this.select.candidate = this.details;

      return this.setSelect(this.select).then(() => {
        this.proceeding = false;

        if (this.ongoing) {
          // this.countdown = this.countdown - 1;
          this.$bvModal.show("modal-resume");
          this.reduceCountdown();
        } else if (this.start_config.start == "Yes") {
          this.$router.push({
            name: "confirm"
          });
        }
      });
    },
    movedown() {
      let categoryName = JSON.parse(this.start_config.category).name;
      // console.log( JSON.parse(this.start_config.category).name)
      this.$router.push({
        name: "testhall",
        params: {
          trackid: this.start_config.track_id,
          category: categoryName,
          institution: this.start_config.institution_shortname
        }
      });
    },
    reduceCountdown() {
      this.countdown = this.countdown - 1;
      setTimeout(() => {
        // this.countdown = this.countdown - 1;
        this.reduceCountdown();
        if (this.countdown == 0) {
          this.movedown();
        }
      }, 1000);
    }
  },

  computed: {
    ...mapState({
      orgspacearray: state => state.dashboard.allorgspaces.data,
      details: state => state.loginmaster.details,
      ongoing: state => state.ongoing,
      start_config: state => state.exam.start_config,
      discountdetails: state => state.loginmaster.details.discount_details
    })
    // substate() {

    //     if(this.select.mode == 'Topic'){
    //         if (this.structure != "Section") {
    //             // Checks if the number of subjects picked is the same as the number of Subjects required for this exam and if all fields has been selected
    //             return this.select.subjects.length == 1 ? true : (false && this.select.institution == null) || this.proceeding;
    //         } else {
    //             // Checks if all required fields has been selected
    //             return (this.select.level != null && this.select.course != null) || this.proceeding
    //         }
    //     }else{
    //         if (this.structure != "Section") {
    //             // Checks if the number of subjects picked is the same as the number of Subjects required for this exam and if all fields has been selected
    //             return this.select.subjects.length == this.allinsti.filter(x => x.name == this.select.institution).map(x => x.num_courses)[0] ? true : (false && this.select.institution == null) || this.proceeding;
    //         } else {
    //             // Checks if all required fields has been selected
    //             return (this.select.level != null && this.select.course != null) || this.proceeding
    //         }
    //     }

    // },
  }
};
</script>

<style>
.card {
  /* min-height: 70vh; */
  background-color: rgb(242, 242, 242);
  border-radius: 20px 20px;
}
.card-title {
  font-size: 1.2rem;
  font-weight: bold;
}
.field-division {
  margin-top: 7px;
}
.v-button {
  border-radius: 10px 10px;
  width: 10rem;
  /* height: 3rem; */
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}
.footer-edit {
  width: 100%;
}
.field-value {
  font-size: 1rem;
  margin-left: 20px;
  /* font-weight: bold; */
}

@media (max-width: 999px) {
  .v-button {
    width: inherit;
    /* height: 2.5rem; */
    font-size: 0.8rem;
  }
  .s-header {
    font-size: 16px;
  }
}
</style>
